module.exports = __webpack_public_path__ + "img/phone-screen-kr.1b282c54.png";